const body = document.getElementById('body');
// const header = document.querySelector('header');

const headerMob = document.querySelector('.header_mobile .header_sub');
const btnMenu = document.getElementById('btn_menu');
const header = document.getElementById('header_site');
const ksaModal = document.querySelectorAll('.ksa_modal');
const mainMenuItems = document.querySelectorAll('#menu-header-menu-1 > .menu-item');

let scrollPrev = 0;
// scrollHeader()
let scrolled = window.scrollY || document.documentElement.scrollTop;
if (scrolled > 80 && scrolled > scrollPrev) {
    header.classList.add('header_scroll');
}

window.addEventListener('scroll', function () {
    scrollHeader()
});

function scrollHeader() {
    let scrolled = window.scrollY || document.documentElement.scrollTop;
    if (scrolled > 80 && scrolled > scrollPrev) {
        header.classList.add('onvisible');
        header.classList.add('header_scroll');
    } else {
        header.classList.remove('onvisible');
    }

    if (scrolled < 80) {
        header.classList.remove('header_scroll');
        header.classList.remove('onvisible');
    }

    scrollPrev = scrolled;
}

let lastScroll = 0;

btnMenu.addEventListener('click', function (e) {
    body.classList.toggle('mm_active')
})


document.addEventListener("DOMContentLoaded", function () {
    let lazyVideos = [].slice.call(document.querySelectorAll("video.lazyload_video"));

    if ("IntersectionObserver" in window) {
        let lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let video = entry.target;
                    let sources = video.querySelectorAll("source");
                    sources.forEach(function (source) {
                        source.src = source.dataset.src;
                    });

                    video.load(); // Загружает видео после добавления src
                    video.classList.remove("lazyload_video");
                    video.classList.add("loaded");
                    lazyVideoObserver.unobserve(video);
                }
            });
        });

        lazyVideos.forEach(function (video) {
            lazyVideoObserver.observe(video);
        });
    }
});